import { ConfirmDialog, StepUpDialog } from '@orgus/ui';
import { closeStepUp, useStepUp } from './run.ts';

/** Renders the confirm or step-up dialog for whichever action asked for one. Mounted once, globally. */
export function StepUpHost() {
  const req = useStepUp((s) => s.request);
  if (!req) return null;
  const onOpenChange = (open: boolean) => {
    if (!open) closeStepUp();
  };
  if (!req.phrase) {
    return (
      <ConfirmDialog
        open
        onOpenChange={onOpenChange}
        title={req.title}
        description={req.description}
        confirmLabel={req.confirmLabel}
        onConfirm={req.run}
      >
        {req.scope.length > 0 && (
          <ul className="flex flex-col gap-0.5 rounded-control border border-border bg-bg px-3 py-2 text-sm text-fg-muted">
            {req.scope.slice(0, 6).map((s, i) => (
              <li key={`${s}-${i}`} className="truncate">
                {s}
              </li>
            ))}
            {req.scope.length > 6 && <li className="text-fg-subtle">and {req.scope.length - 6} more</li>}
          </ul>
        )}
      </ConfirmDialog>
    );
  }
  return (
    <StepUpDialog
      open
      onOpenChange={onOpenChange}
      title={req.title}
      description={req.description}
      risk={req.risk}
      scope={req.scope}
      phrase={req.phrase}
      confirmLabel={req.confirmLabel}
      onConfirm={req.run}
    />
  );
}
